import React from "react";
import { useApp } from "../context/AppContext";
import MealCard from "../components/MealCard";
import { useI18n } from "../context/I18nContext";

export default function Favorites({ navigate }) {
  const { state } = useApp();
  const { t } = useI18n();
  const { favorites } = state;

  return (
    <div>
      <div className="page-header">
        <h1>♥ {t("favorites")}</h1>
        <p>{t("favoritesIntro")}</p>
      </div>

      {favorites.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">♡</div>
          <h3>{t("noFavorites")}</h3>
          <p>{t("favoriteHint")}</p>
          <button className="btn btn-primary" onClick={() => navigate("meals")}>
            {t("browseMeals")}
          </button>
        </div>
      ) : (
        <>
          <p className="result-count">{favorites.length} {t("favoriteRecipeCount")}</p>
          <div className="meals-grid">
            {favorites.map((meal, index) => (
              <MealCard
                key={meal.id}
                meal={meal}
                showDessertType={meal.mealType === "dessert"}
                onClick={() => navigate("detail", meal)}
                style={{ animationDelay: `${index * 25}ms` }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
